import getApiUrl from "./getUrl";
import getUrl from "./getUrl";
import {encodeToBase64Unicode} from "../business/crypto/encode";

export async function adapterConfig(json){

    try {
        const res = await fetch(getUrl()+"/api/adapter/control", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(json),
            credentials: "include", // Include cookies with the request
        });

        return res
    } catch (err) {

    }
}